module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/login-bg-9e6c7d24cb5d2ed16839e27f213c346b.jpg";